import { StreamActions } from "@hotwired/turbo"

// Custom Turbo Stream Action: update_badge
//
// Purpose: Update badge counts inside data-turbo-permanent containers
//
// Problem: Turbo Streams cannot update elements nested inside data-turbo-permanent
// containers because Turbo preserves these elements during navigation and ignores
// stream replace/update actions targeting elements within them.
//
// Solution: Instead of directly manipulating the DOM, this custom action dispatches
// a JavaScript event that badge_sync_controller listens for and handles via direct
// DOM manipulation, bypassing the data-turbo-permanent restriction.
//
// Server-side usage:
//   Turbo::StreamsChannel.broadcast_action_to(
//     "navigation_#{user.id}",
//     action: :update_badge,
//     target: "notification_badge",
//     attributes: { count: 5 }
//   )
//
// Expected <turbo-stream> format:
//   <turbo-stream action="update_badge" target="notification_badge" count="5"></turbo-stream>
//
// IMPORTANT: Use regular function() syntax, not arrow function, because `this`
// must reference the StreamElement instance to access getAttribute().
StreamActions.update_badge = function() {
  const targetId = this.getAttribute("target")
  const countAttr = this.getAttribute("count")
  const count = countAttr !== null ? parseInt(countAttr, 10) : 0

  // Dispatch custom event for badge_sync_controller to handle
  // This bypasses data-turbo-permanent restrictions by using direct DOM manipulation
  window.dispatchEvent(new CustomEvent("badge:update", {
    detail: { targetId, count },
    bubbles: false
  }))

  console.debug(`[TurboStream:update_badge] Dispatched badge:update - target: ${targetId}, count: ${count}`)
}
